import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Cookies from 'js-cookie';
import arrowUp from '../../assets/icons/arrow_down.svg';
import arrowUpBlue from '../../assets/icons/arrow_down_blue.svg';
import SectionsInfo from '../SectionsInfo';
import useWindowSize from '../../hooks/useWindowSize';
import removeHtmlTags from '../../helpers/removeHtmlTags';

function Faq({ data, isService = false }) {
  const { width } = useWindowSize();
  const lang = Cookies.get('i18next') || 'en';
  return (
    <div className="faq__main">
      {width > 768 && !isService && <div className="faq__blur" />}
      <div className="container">
        <div className={`faq-content ${isService ? 'faq_content_service' : ''}`}>
          <div className="faq">
            <SectionsInfo
              isFaq
              center
              isSlider={false}
              isPartner={false}
              title={data.title[lang]}
              description={data.content_title[lang]}
            />
            <Accordion
              collapseIcon={() => (
                <button className="accordion-collapse-btn" type="button">
                  <img src={arrowUp} alt="arrow up" />
                </button>
              )}
              expandIcon={() => (
                <button className="accordion-expand-btn" type="button">
                  <img src={arrowUpBlue} alt="arrow up" />
                </button>
              )}
              className="faq__accordion"
              activeIndex={0}
            >
              {data.data.map((e) => (
                <AccordionTab
                  key={e.id}
                  contentClassName="faq__accordion-content"
                  className="accordion-tab"
                  headerClassName="accordion-header"
                  header={removeHtmlTags(e.question[lang])}
                >
                  <blockquote>
                    {removeHtmlTags(e.answer[lang])}
                  </blockquote>
                </AccordionTab>
              ))}
            </Accordion>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Faq;
